module.exports = __webpack_public_path__ + "static/media/background_3.5c704fcf.png";